<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <Header />

    <b-card class="bCardGlobal">
      <b-row class="titulo">
        <b-col class="seccionTitulo">
          <span class="fa fa-table"></span>
          <span>Solicitud de servicio</span>
        </b-col>
        <b-col class="seccionCodigo">
          <div>C-**</div>
        </b-col>
      </b-row>

      <b-row class="divSubtitulo">
        <b-col>
          <p class="textSubtitulo ">Bitácora de solicitudes</p>
        </b-col>
        <b-col class="text-right">
          <b-button
              v-if="intentos.length >0"
              v-b-tooltip.hover
              title="Historial de intentos"
              variant="ligth"
              @click="modalIntentos = true"
          >
            <font-awesome-icon icon="history"/>
          </b-button>
        </b-col>
      </b-row>
      <div class="container-fluid main-component ">
        <div class="row justify-content-center">
          <div class="col-sm-12 col-md-8 col-lg-8 col-xl-5">
            <b-card
                style="
                padding: 1%;
                border-radius: 20px;
                box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
              "
            >
              <p
                  style="
                  text-align: left;
                  color: #093974;
                  font-size: 18px;
                  font-weight: 600;
                "
              >
                Información del paciente
              </p>
              <b-table-simple responsive style="margin-top: 7%">
                <tr>
                  <td style="font-size: 15px"><label>ID Paciente</label></td>
                  <td style="font-size: 15px">{{ datos.idPaciente }}</td>
                </tr>
                <tr>
                  <td style="font-size: 15px">
                    <label>Nombre del Paciente</label>
                  </td>
                  <td style="font-size: 15px">{{ datos.paciente }}</td>
                </tr>
              </b-table-simple>
              <div style="margin-top: 10%">
                <p>
                  A través de <strong>{{ datos.origen }}</strong> el paciente
                  comenta:
                </p>
                <p v-if="datos.comentarios.length < 160">
                  <strong>{{ datos.comentarios }}</strong>
                </p>
                <b-button v-else @click="modalComentarios=true">Ver comentarios</b-button>
              </div>
            </b-card>
          </div>

          <div class="col-sm-12 col-md-12 col-lg-12 col-xl-7">

            <div class="container-fluid main-component " style="margin-top: 3%">

              <div class="row justify-content-between">

                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-5">


                  <p
                      style="
                        text-align: left;
                        color: #093974;
                        font-size: 18px;
                        font-weight: 600;
                      "
                  >
                    Intentos
                  </p>
                  <p style="text-align: left">
                    <strong>Fecha programada de contacto: </strong
                    >{{ intento.fechaCompromiso | formatoFecha }}
                  </p>
                  <b-form-group align="left">
                    <label for="nombre">Estatus del contacto</label>
                    <v-select
                        id="estatus"
                        name="estatus"
                        placeholder="Estatus"
                        label="descripcion"
                        :options="estatus"
                        :reduce="(i) => i.idEstatus"
                        v-model="$v.intento.idEstatus.$model"
                        :state="validateState('idEstatus')"
                        :class="selectClass('idEstatus')"
                    ></v-select>
                  </b-form-group>
                  <div>
                  </div>
                </div>

                <div v-if="datos.idPaciente != ''" class="col-sm-12 col-md-6 col-lg-6 col-xl-7">
                  <ContactoPaciente
                      :idPaciente="datos.idPaciente"
                      @_setearValor="setearValor"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="container-fluid main-component mt-4" >

        <div class="row justify-content-between">

          <div class="col-sm-12 col-md-9 col-lg-9 col-xl-9">
            <b-form-group align="left">
              <label>Comentarios o respuesta del paciente SLA2</label>
              <b-form-textarea
                  v-model="$v.intento.observacionesContacto.$model"
                  :state="validateState('observacionesContacto')"
              >
                ></b-form-textarea
              >
            </b-form-group>
          </div>
          <div class="col-sm-12 col-md-3 col-lg-3 col-xl-3 mt-5">

            <b-button
                variant="outline-primary"
                :disabled="loaderGuardar"
                @click="guardar()"
            >
              <span v-if="!loaderGuardar">Guardar</span>
              <span v-if="loaderGuardar">
                <b-spinner small></b-spinner>
                Cargando...
              </span>
            </b-button>
          </div>
        </div>
      </div>
    </b-card>
    <b-modal
        v-model="modalComentarios"
        title="Comentarios del paciente"
        scrollable
        size="xl"
    >
      <p style="font-size: 18px; font-weight: 600; ">El paciente comenta:</p>
      <div class="container-fluid main-component p-3 text-justify">

        <p>{{datos.comentarios}}</p>
      </div>
    </b-modal>

    <b-modal
        size="xl"
        v-model="modalIntentos"
        id="modalIntentos"
        title="Registro de contactos del paciente"
        scrollable
    >
      <div style="margin: 3%">
        <div>
          <b-card
              style="
              padding: 1%;
              width: 100%;
              border-radius: 20px;
              box-shadow: rgba(0, 0, 0, 0.1) 0px 4px 12px;
            "
              v-for="(item, i) in intentos"
              :key="'Intento'+i"
          >
            <b-row>
              <b-col>{{item.fechaContacto|formatoFechaHora}}</b-col>
              <b-col cols="8">{{item.observacionesContacto}}</b-col>
              <b-col>{{item.estatus}}</b-col>
            </b-row>
          </b-card>

        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import Header from "../../../components/Header";
import { required } from "vuelidate/lib/validators";
import { GarantiaService } from "../../../apiServices/garantias/GarantiaService";
import { CatalogosService } from "../../../apiServices/catalogos/CatalogosService";
import ContactoPaciente from "../../../components/paciente/ContactoPaciente";

export default {
  name: "IntentosSLA",
  components: { ContactoPaciente, Header },
  data: () => {
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,

      garantiaServicio: new GarantiaService(),
      catalogoServicio: new CatalogosService(),
      idTicket: null,
      idEtapa: null,
      datos: {
        origen: "",
        comentarios: "",
        idPaciente: "",
        paciente: "",
        driver: "",
        tema: "",
        subtema: "",
      },
      estatus: [],
      intentos: [],
      loaderGuardar: false,
      intento: {
        idSeguimientoContacto: null,
        fechaCompromiso: null,
        idEstatus: null,
        motivoContacto: null,
        observacionesContacto: null,
      },
      contactoSeleccionado: null,
      modalContacto: false,
      modalComentarios:false,
      modalIntentos: false,
    };
  },
  validations: {
    intento: {
      idEstatus: { required },
      observacionesContacto: { required }
    },
  },
  created() {
    this.debug = this.$localStorageService.getDebug();

    this.idTicket = this.$route.params.id;
    this.idEtapa = this.$route.params.idEtapa;
    this.obtenerInformacionTicket();
    this.obtenerRegistroContacto();
    this.obtenerEstatus();
    this.obtenerIntentos();
  },
  methods: {
    obtenerIntentos(){
      const parametros = {idSolicitud: this.idTicket}
      this.garantiaServicio.obtenerIntentos(parametros)
          .then(response => {
            this.intentos = response.data
          })
    },
    abrirModalContacto() {
      this.modalContacto = true;
    },
    setearValor(valor) {
      this.contactoSeleccionado = valor;
    },
    obtenerEstatus() {
      this.catalogoServicio.estatusContactos().then((respuesta) => {
        this.estatus = respuesta.data;
      });
    },
    obtenerInformacionTicket() {
      const parametros = {idTicket: this.idTicket}
      this.garantiaServicio.obtenerTicket(parametros).then((respuesta) => {
        this.datos = respuesta.data;
      });
    },
    obtenerRegistroContacto() {
      const parametros = {idSolicitud: this.idTicket}
      this.garantiaServicio
          .obtenerRegistroContacto(parametros)
          .then((respuesta) => {
            this.intento = respuesta.data;
          });
    },
    guardar() {
      this.$v.intento.$touch();
      if (this.$v.intento.$anyError) {
        return false;
      }

      const envio = JSON.parse(JSON.stringify(this.intento));

      envio.fecha = new Date();
      envio.idTicket = this.idTicket;
      envio.idEtapa = this.idEtapa;

      this.loaderGuardar = true;
      this.garantiaServicio
          .guardarIntentos(envio)
          .then(() => {
            this.$swal({
              icon: "success",
              title: "Se registro correctamente",
              showConfirmButton: false,
            });
            this.$v.$reset();
              window.history.back();
          })
          .finally(() => {
            this.loaderGuardar = false;
          });
    },

    validateState(name) {
      const { $dirty, $error } = this.$v.intento[name];
      return $dirty ? !$error : null;
    },
    selectClass(attribute) {
      let state = this.validateState(attribute);
      if (state) {
        return "border rounded-lg border-success";
      } else if (state === false) {
        return "border rounded-lg border-danger";
      } else {
        return "";
      }
    },
  },
};
</script>

<style scoped>
.bCardGlobal {
  margin: 2% 4% 2% 4%;
  padding: 0.5% 1% 0.5% 1%;
  border-radius: 20px;
}

.divSubtitulo {
  width: 100%;
  margin-top: 2%;
  border-bottom: 5px solid #8ec6e9;
}

.divInput {
  margin-left: 1%;
  margin-right: 3%;
}

.textSubtitulo {
  color: #093974;
  font-weight: 600;
  font-size: 22px;
  text-align: left;
}

.overflow-ellipsis {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.container-fluid.history {
  background-color: green;
}
</style>
